import pathOr from 'ramda/src/pathOr';
import path from 'ramda/src/path';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import { BoolHelper, MetadataHelpers } from 'invision-core/index';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
var CONSENT_KEYS = {
  COUNTRIES: 'countries',
  NAME: 'consent_name',
  MODIFIED_DATE: 'mod_date',
  REQUIRED: 'is_required',
  TERMS: 'consent_terms'
};
export var addressStateRegionProvinceValueOptionsForCountry = function addressStateRegionProvinceValueOptionsForCountry(country, countryCodes, stateCodes) {
  var states = country && MetadataHelpers.codes.statesForCountry(country, countryCodes, stateCodes) || [];
  return states.length && MetadataHelpers.codes.selectOptionsForCodeValues(states) || null;
};
export var selectOptionsForAlphabetizedCodeValues = function selectOptionsForAlphabetizedCodeValues(codes, currencies) {
  return codes.map(function (code) {
    var currencyCode = currencies[findAdditionalProperty(code.AdditionalProperties, 'default_preferred_tax_reporting_currency').Value];
    return {
      label: currencyCode.Name,
      value: findAdditionalProperty(code.AdditionalProperties, 'default_preferred_tax_reporting_currency').Value
    };
  });
};
export var selectOptionsForAlphabetizedCurrencyValues = function selectOptionsForAlphabetizedCurrencyValues(currencies, defaultCurrency, customerId) {
  if (!defaultCurrency || customerId) {
    return [{
      label: i18n.translate(CoreLocaleKeys.SELECT),
      value: null
    }].concat(Object.values(currencies).map(function (code) {
      return {
        label: code.Name,
        value: code.Value
      };
    }));
  }
  return Object.values(currencies).map(function (code) {
    return {
      label: code.Name,
      value: code.Value
    };
  });
};
export var getPreferredTaxDefaultCurrency = function getPreferredTaxDefaultCurrency(currencies, country) {
  var defaultCurrencyCode = currencies.find(function (code) {
    return findAdditionalProperty(code.AdditionalProperties, 'country').Value === country;
  });
  return defaultCurrencyCode ? findAdditionalProperty(defaultCurrencyCode.AdditionalProperties, 'default_preferred_tax_reporting_currency').Value : null;
};
export var consentsForCountry = function consentsForCountry(country, consentsByBU) {
  var matchedConsents = [];
  consentsByBU.forEach(function (c) {
    var flag = false;
    var consent = {
      description: '',
      id: c.Value,
      isAccepted: undefined,
      // *undefined* helps identify whether the CSR intentionally rejected an optional consent.
      isModifiedAfterAcceptance: false,
      isRequired: false,
      modifiedDate: '',
      title: ''
    };
    c.AdditionalProperties.forEach(function (prop) {
      switch (prop.Key) {
        case CONSENT_KEYS.COUNTRIES:
          if (country && prop.Value.match(country)) {
            flag = true;
          }
          break;
        case CONSENT_KEYS.NAME:
          consent.title = prop.Value;
          break;
        case CONSENT_KEYS.MODIFIED_DATE:
          consent.modifiedDate = prop.Value;
          break;
        case CONSENT_KEYS.REQUIRED:
          consent.isRequired = BoolHelper.getBoolOrDefault(prop.Value, true);
          break;
        case CONSENT_KEYS.TERMS:
          consent.description = prop.Value;
          break;
        default:
          break;
      }
    });
    if (flag) {
      matchedConsents.push(consent);
    }
  });
  return matchedConsents;
};
function findAdditionalProperty(additionalProperties, targetProperty) {
  var findPropertyByKey = function findPropertyByKey(property) {
    return property.Key === targetProperty;
  };
  return additionalProperties.find(findPropertyByKey);
}
export var currencyValuesForCountry = function currencyValuesForCountry(countryCode, currencies) {
  return currencies && MetadataHelpers.codes.currenciesForCountry(countryCode, currencies) || [];
};
export var currencyValueOptionsForCountry = function currencyValueOptionsForCountry(countryCode, currencies) {
  var countryCurrencies = currencies && MetadataHelpers.codes.currenciesForCountry(countryCode, currencies) || [];
  return countryCurrencies.length && MetadataHelpers.codes.codeValueOptionsWithoutPlaceholder(countryCurrencies) || null;
};
export var getCustomerCurrencyName = function getCustomerCurrencyName(customer, SubscriberCurrencies) {
  var selectedCurrency = SubscriberCurrencies.find(function (currency) {
    return currency.Value === customer.SubscriberCurrency;
  });
  return pathOr(customer.SubscriberCurrency, ['Name'], selectedCurrency);
};
export var getCustomerHomeCountryName = function getCustomerHomeCountryName(customer, homeCountries) {
  var selectedCountry = homeCountries.find(function (country) {
    return country.Value === customer.HomeCountry;
  });
  return pathOr(customer.HomeCountry, ['Name'], selectedCountry);
};
export var getCustomerInvoiceDetailStatus = function getCustomerInvoiceDetailStatus(customer, invoiceDetailLevels) {
  var currentLevel = path(['InvoiceConfiguration', 'InvoiceDetailLevel'], customer);
  currentLevel = currentLevel && "".concat(currentLevel);
  return path(['Name'], find(propEq(currentLevel, 'Value'))(invoiceDetailLevels));
};
export var getCustomerAdditionalPropertiesSortedByDisplayOrder = function getCustomerAdditionalPropertiesSortedByDisplayOrder(customerAdditionalProperties, subscriberAdditionalPropertyFields) {
  var selectedCustomerAdditionalProps = customerAdditionalProperties.asMutable({
    deep: true
  });
  var findPropertyById = function findPropertyById(prop) {
    return prop.id === this.Id;
  };
  var sortByDisplayOrder = function sortByDisplayOrder(a, b) {
    return subscriberAdditionalPropertyFields.findIndex(findPropertyById, a) - subscriberAdditionalPropertyFields.findIndex(findPropertyById, b);
  };
  return selectedCustomerAdditionalProps.length > 1 && subscriberAdditionalPropertyFields.length > 1 ? selectedCustomerAdditionalProps.sort(sortByDisplayOrder) : selectedCustomerAdditionalProps;
};